import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { DropTarget as dropTarget } from 'react-dnd'

import { getDateTimeDeals, getPerformanceId } from 'selectors/grid'
import { getCurrentPartnerId } from 'selectors/settings'
import { gridCreateDeal } from 'actions/grid'
import { getPartnerUrl } from 'utils/urls'
import { GRID_DND_SIDEBAR_SELLABLE_ITEM } from 'constants/grid-constants'

import GridCell from './grid-cell'

class GridCellContainer extends Component {
  render() {
    const { connectDropTarget } = this.props

    return connectDropTarget(
      <div>
        <GridCell {...this.props} />
      </div>
    )
  }
}

GridCellContainer.propTypes = {
  connectDropTarget: PropTypes.func.isRequired,
}

const gridCellTarget = {
  drop(props, monitor) {
    const item = monitor.getItem()
    props.gridCreateDeal(props.dateId, props.timeId, item.sellableItem.id)
  },
}

const collect = (targetConnect, monitor) => {
  const isOver = monitor.isOver()
  return {
    isOver,
    connectDropTarget: targetConnect.dropTarget(),
    color: isOver ? monitor.getItem().sellableItem.color : '',
    canDrop: monitor.canDrop(),
  }
}

const mapStateToProps = (state, ownProps) => {
  const dateId = ownProps.dates.toIndexedSeq().get(ownProps.rowIndex).get('id')
  const timeId = ownProps.times.toIndexedSeq().get(ownProps.columnIndex).get('id')
  const deals = getDateTimeDeals(dateId, timeId)(state)
  const performanceId = getPerformanceId(dateId, timeId)(state)
  const partnerId = getCurrentPartnerId(state)
  let performanceUrl

  if (performanceId) {
    performanceUrl = getPartnerUrl(partnerId, `/performance/${performanceId}`)
  }

  return {
    dateId,
    timeId,
    deals,
    performanceUrl,
  }
}

const mapDispatchToProps = { gridCreateDeal }

const DNDGridCell = dropTarget(GRID_DND_SIDEBAR_SELLABLE_ITEM, gridCellTarget, collect)(GridCellContainer)
export default connect(mapStateToProps, mapDispatchToProps)(DNDGridCell)



/** WEBPACK FOOTER **
 ** ./src/components/grid/grid-cell/grid-cell-container.js
 **/